import React from 'react';
import { Button, Col, Container, Row } from 'react-bootstrap';

import './lottery_styles/lotterylower.css';

export default function LotteryLower() {
  return (
    <>
      <Container className='mt-5 mb-5'>
        <Row>
          <Col>
            <div className="lot_lower d-flex flex-column justify-content-center align-items-center">
              <div className="lot_lower_head">
                <p>THE TYPES OF TOKEN REWARDS ARE ANY OF THE FOLLOWING: ET, USDT, BTC, ETH, FIL, DOGE: UPTO 
                  2000 USDT OR 2000 ET!!
                </p>
              </div>
              <div className="lot_lower_btn">
                <Button>VIEW MORE</Button>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  )
}
